import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { addOpacity } from 'lib/helpers';
import { LoadingTypography } from 'lib/LoadingTypography';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';

const PREFIX = 'PayTableInfo';

const classes = {
    change: `${PREFIX}change`,
    buttonBase: `${PREFIX}buttonBase`,
    subtitle: `${PREFIX}subtitle`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.change}`]: {
        color: theme.palette.primary.main,
        fontWeight: 700
    },

    [`& .${classes.buttonBase}`]: {
        display: 'flex',
        flexDirection: 'column'
    },

    [`& .${classes.subtitle}`]: {
        color: addOpacity(theme.palette.text.primary, 0.4)
    }
}));

interface PayTableInfoProps {
    isLoading: boolean;
    table?: string | null;
    checkId?: string | null;
    disableEdit?: boolean;
}

const SPLITTER_ELEMENT = ' | ';

export const PayTableInfo: React.FC<React.PropsWithChildren<PayTableInfoProps>> = ({
    isLoading,
    table,
    checkId,
    disableEdit
}) => {
    const { settings } = useSelector((state: ApplicationState) => state.settings);

    const { t } = useTranslation();
    const showCheckId = React.useMemo(
        () =>
            (settings?.payAtTable?.retrievalBy === 'BOTH' && !table) ||
            settings?.payAtTable?.retrievalBy === 'CHECK_NUMBER',
        [settings?.payAtTable?.retrievalBy, table]
    );
    return (
        <StyledBox display="flex" alignItems="center">
            <LoadingTypography className={classes.subtitle} loading={isLoading} width={80}>
                {showCheckId
                    ? t('BILL_CHECK_NUMBER', { checkId })
                    : t('BILL_TABLE_NUMBER', { tableNumber: table })}
            </LoadingTypography>
            {!disableEdit && (
                <Box px={1}>
                    <Typography className={classes.subtitle}>{SPLITTER_ELEMENT}</Typography>
                </Box>
            )}
            {!disableEdit && (
                <LoadingTypography className={classes.change} width={80} loading={isLoading}>
                    {t('GENERAL_EDIT')}
                </LoadingTypography>
            )}
        </StyledBox>
    );
};
